// extracted by mini-css-extract-plugin
module.exports = {"dark":"ThemeContext-styles-module--dark--Wa00k","light":"ThemeContext-styles-module--light--1mra7"};